import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'purchaseChannel'>,
  Pick<ReqCreateOrUpdateChallenge, 'purchaseChannel'>
> = ({ purchaseChannel }) => ({ purchaseChannel });

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'purchaseChannel'>,
  Pick<ChallengeFormType, 'purchaseChannel'>
> = ({ purchaseChannel }) => ({ purchaseChannel });
